import { useCallback, useMemo } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { ExtendedSearchParams } from '@/forApp/utils/extendedSearchParams';

type SetExtendedSearchParams = (
  nextInit?:
    | ExtendedSearchParams
    | ((prev: ExtendedSearchParams) => ExtendedSearchParams),
) => void;

export const useSetSearchParams = (): [
  ExtendedSearchParams,
  SetExtendedSearchParams,
] => {
  const router = useRouter();
  const pathname = usePathname();
  const sp = useSearchParams();
  const spString = sp.toString();

  const searchParams = useMemo(
    () => new ExtendedSearchParams(spString),
    [spString],
  );

  const setSearchParams = useCallback<SetExtendedSearchParams>(
    (updater) => {
      if (!updater) return;

      const nextParams =
        typeof updater === 'function'
          ? updater(new ExtendedSearchParams(spString))
          : updater;

      router.push(`${pathname}?${nextParams.toString()}`, { scroll: false });
    },
    [router, pathname, spString],
  );

  return [searchParams, setSearchParams];
};
